import React, { useState } from "react";
import RequestFindMobile from "../../components/common/mobile/RequestFindMobile";
import { Helmet } from "react-helmet";
import { useRouteInfo } from "../../hooks/useRouteInfo";

const TargetedBuyMobilePage = () => {
  const [selected, setSelected] = useState();
  const { metaData } = useRouteInfo();
  return (
    <div className="pt-2">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>{" "}
      <h1 className="title-mobile text-center mb-4">{metaData?.h1}</h1>
      <p className="text-justify text-[14px] sm:text-[16px] text-[#393C3D] leading-6">
        اگه دنبال خرید ماشین سنگین با بودجه‌ای که مد نظرتونه هستید، از 1924 دست
        خالی بیرون نمی‌رید!
        <br /> تو 1924 ما با قوی‌ترین تیم مشاوره خرید و فروش ماشین‌های سنگین
        کنار شماییم تا مطمئن بشیم بهترین انتخاب رو بر اساس نیاز و سرمایتون
        می‌کنید. اینجا، سرمایه شما برامون مهمه و با مشاوره‌های هوشمندانه و تخصصی
        کمک می‌کنیم تا یه خرید موفق داشته باشید.
      </p>
      <div className="flex flex-col gap-3 py-7">
        <span
          id="خودرو اقتصادی"
          onClick={() => setSelected("خودرو اقتصادی")}
          className={`${
            selected === "خودرو اقتصادی" && "bg-black text-secendory"
          } border-brand-2 flex flex-col gap-4 items-center justify-center py-5 cursor-pointer`}
        >
          <h3 className="font-[700] text-[24px]">خرید خودرو اقتصادی</h3>
          <p>خودرو های متناسب با بودجه شما</p>
        </span>
        <span
          id="خودرو کاری"
          onClick={() => setSelected("خودرو کاری")}
          className={`${
            selected === "خودرو کاری" && "bg-black text-secendory"
          } border-brand-2 flex flex-col gap-4 items-center justify-center py-5 cursor-pointer`}
        >
          <h3 className="font-[700] text-[24px]">خرید خودرو کاری</h3>
          <p>خودرو هایی با توان بالا</p>
        </span>
        <span
          id="خودرو جدید"
          onClick={() => setSelected("خودرو جدید")}
          className={`${
            selected === "خودرو جدید" && "bg-black text-secendory"
          } border-brand-2 flex flex-col gap-4 items-center justify-center py-5 cursor-pointer`}
        >
          <h3 className="font-[700] text-[24px]">خرید خودرو جدید</h3>
          <p>جدید ترین خودرو ها</p>
        </span>
      </div>
      {selected && <RequestFindMobile />}
    </div>
  );
};

export default TargetedBuyMobilePage;
